<template>
	<section v-if="closestLocations && closestLocations?.length > 0" class="location-closest-branches">
		<div class="location-closest-branches__content">
			<h2 class="location-closest-branches__title">
				{{ $t('modules.location_module.location.closest_branches.other_locations_in_the_region') }}
			</h2>
			<div class="location-closest-branches__locations">
				<NuxtLink
					v-for="location in closestLocations"
					:key="location.id"
					class="location-closest-branches__location"
					:to="getURLforLocation(location)">
					<div class="location-closest-branches__location-name-box">
						<div class="location-closest-branches__location-name">{{ location[`name${locale?.toUpperCase()}`] }}</div>
						<div class="location-closest-branches__location-subtitle">{{ location[`subtitle${locale?.toUpperCase()}`] }}</div>
					</div>
					<GlobalIcon name="location-bold" :height="20" color="var(--primary-color)"></GlobalIcon>
				</NuxtLink>
			</div>
			<ButtonPrimary :to="localePath('locations')" class="location-closest-branches__btn">
				{{ $t('modules.location_module.location.closest_branches.check_all_places') }}
			</ButtonPrimary>
		</div>
	</section>
</template>

<script setup lang="ts">
const { locale } = useI18n()
const localePath = useLocalePath()

const closestLocations = inject<Ref<ICMSLocationModel[]>>('closestLocations') || ref<ICMSLocationModel[]>([])

// const getURLforLocation = (item: ICMSLocationRelatedExtendedModel | null) => {
// 	if (!item) return undefined
// 	const url = item[`url${locale.value.toUpperCase()}`]

// 	if (url) return localePath({ name: 'car-rental-urlSlug', params: { urlSlug: url } })
// 	else return undefined
// }
const getURLforLocation = (item: ICMSLocationModel & { translation_key_title: string }) => {
	const urlLocale = item[`isActive${locale.value.toUpperCase()}`] ? item[`url${locale.value.toUpperCase()}`] : undefined
	const url = item.urlPL

	if (!url && !urlLocale) return undefined
	else
		return urlLocale
			? localePath({ name: 'car-rental-urlSlug', params: { urlSlug: urlLocale } }, locale.value)
			: localePath({ name: 'car-rental-urlSlug', params: { urlSlug: url } }, 'pl')
}
</script>

<style lang="scss">
@import './ClosestBranches.scss';
</style>
